import styled, { css } from 'styled-components';

// images
import spin1 from '../../resources/images/spin1.png';
import spin2 from '../../resources/images/spin2.png';

// animations
import { spinPulse, spinOffPulse } from '../../animations/keyframes'

const Loading = () => {
  return (
    <LoadingContainer>
      <CircleOne src={spin1} alt="xogene-loaing-spinner"></CircleOne>
      <CircleTwo src={spin2} alt="xogene-loaing-spinner"></CircleTwo>
    </LoadingContainer>
  );
};
export default Loading;

const spinPulseMixin = css`
  animation:  ${spinPulse} 2s linear infinite;
`

const spinOffPulseMixin = css`
  animation:  ${spinOffPulse} 2s linear infinite;
`

const LoadingContainer = styled.div`

`;

const CircleOne = styled.img`
  opacity: 0.9;
  width: 90px;
  height: 90px;
  background-size: 90px 90px;
  margin-left: -50px;
  margin-top: -90px;
  position: fixed;
  top: 50%;
  left: 50%;
  ${spinPulseMixin}
`

const CircleTwo = styled.img`
  opacity: 0.9;
  background-size: 90px 90px;
  width: 90px;
  height: 90px;
  margin-left: -50px;
  margin-top: -90px;
  position: fixed;
  left: 50%;
  top: 50%;
  ${spinOffPulseMixin}
`